import React, { useState } from "react";
import { ChatIcon, SendIcon } from "./HelpCenterIcons";

const CATEGORIES = [
  "Select a category",
  "Technical Issue",
  "Billing",
  "Feature Request",
  "Account",
  "Other",
];

const HelpCenterContactForm = () => {
  const [subject, setSubject] = useState("");
  const [category, setCategory] = useState("");
  const [message, setMessage] = useState("");

  return (
    <div className="v2-help-pg-card">
      <div className="v2-help-pg-card__header">
        <div className="v2-help-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <ChatIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-help-pg-card__title">Contact Support</h3>
          <p className="v2-help-pg-card__subtitle">
            Can't find what you're looking for? Send us a message
          </p>
        </div>
      </div>

      <div className="v2-help-pg-form">
        <div className="v2-help-pg-form__row">
          <div className="v2-help-pg-form__field">
            <label className="v2-help-pg-form__label">Subject</label>
            <input
              type="text"
              className="v2-help-pg-form__input"
              placeholder="Brief description of your issue"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
          <div className="v2-help-pg-form__field">
            <label className="v2-help-pg-form__label">Category</label>
            <select
              className="v2-help-pg-form__select"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              {CATEGORIES.map((cat) => (
                <option key={cat} value={cat === "Select a category" ? "" : cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="v2-help-pg-form__field">
          <label className="v2-help-pg-form__label">Message</label>
          <textarea
            className="v2-help-pg-form__textarea"
            placeholder="Describe your issue in detail..."
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <button className="v2-help-pg-form__submit">
          <SendIcon size={16} color="#ffffff" />
          <span>Send Message</span>
        </button>
      </div>
    </div>
  );
};

export default HelpCenterContactForm;
